import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { getAmountOfRegularSavings } from '@app/features/my-needs/my-needs';
import { Subscriber } from 'rxjs/Subscriber';

@Component({
  selector: 'app-my-regular-saving-plan',
  templateUrl: './my-regular-saving-plan.component.html',
  styleUrls: ['./my-regular-saving-plan.component.css']
})
export class MyRegularSavingPlanComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Output('changeAmountOfRegularSavings') amountOfRegularSavingsEventEmitter = new EventEmitter<number>();
  @Output() closeModal = new EventEmitter();

  amountOfRegularSavings: number;
  formChangedSubcriber: Subscriber<any>;

  ngOnInit() {
    this.amountOfRegularSavings = getAmountOfRegularSavings(
      this.data.form.value.myYearlyIncome,
      this.data.form.value.savingPercentForYearlyIncome,
      this.data.form.value.currentSavings,
      this.data.form.value.otherSavings,
      this.data.form.value.timeSavings - 1,
      this.data.form.value.investmentRates,
      this.data.form.value.inflationRates
    );

    this.formChangedSubcriber = this.data.form.valueChanges.subscribe(formValue => {
      this.amountOfRegularSavings = getAmountOfRegularSavings(
        formValue.myYearlyIncome,
        formValue.savingPercentForYearlyIncome,
        formValue.currentSavings,
        formValue.otherSavings,
        formValue.timeSavings - 1,
        formValue.investmentRates,
        formValue.inflationRates
      );
    });
  }

  ngOnDestroy() {
    this.formChangedSubcriber.unsubscribe();
    this.amountOfRegularSavingsEventEmitter.emit(this.amountOfRegularSavings);
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-needs/my-regular-saving-plan/my-regular-saving-plan.component.ts